import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import WatchList, { FAVORITE_PLUS_HOVER, FAVORITE_TYPE_WATCHLIST } from 'components/Favorite';
import { browsePosterProcessor } from '../../processors/index';
import { SimplifiedImage, HoverStateToolTip, Overlay } from '../../components';
import Style from '../../styles/BrowsePoster.module.scss';

const BrowsePoster = ({
  account,
  breakpoint,
  favoritesManager,
  isGrid,
  isPersonality,
  item,
  itemIndex,
  preventLazyLoad,
  segmentPlaylistButtonAction,
}) => {
  const [isFavorite, setFavorite] = useState(false);
  const {
    badge,
    link: route,
    name,
    onPosterClick,
    overlayProps,
    posterAltText,
    posterImage,
  } = browsePosterProcessor({
    account,
    isPersonality,
    item,
  });
  const { description } = item;
  const getCarouselPosterClasses = [];
  const favorites = favoritesManager?.favorites;
  const favoriteData = overlayProps?.favoriteData;

  useEffect(() => {
    const isFavorite = () => {
      let results = [];
      if (!favoritesManager || !favoritesManager.favorites) return false;
      favoriteData?.favoritableItems?.forEach(item => {
        const matches = favoritesManager.favorites.filter(
          favorite => item.id === favorite.favoriteID,
        );
        results = [...matches, ...results];
      });
      return results.length > 0;
    };
    setFavorite(isFavorite());
  }, [favoriteData, favoritesManager]);

  if (isGrid) {
    getCarouselPosterClasses.push(Style.gridPoster);
  }

  const posterImageProps = {
    badge,
    breakpoint,
    image: posterImage,
    isGrid,
    item,
    onPosterClick,
    posterAltText: posterAltText || name,
    preventLazyLoad,
    route,
    theme: Style,
  };

  return (
    <div className={classNames(getCarouselPosterClasses)} key={itemIndex}>
      <SimplifiedImage {...posterImageProps} />
      {favoritesManager && (
        <Overlay theme={Style}>
          <span className={Style.watchList}>
            <span className={Style.watchListButtonContainer}>
              <WatchList
                data={{ ...favoriteData, titleText: name, subtitleText: description }}
                favorites={favorites}
                iconType={FAVORITE_PLUS_HOVER}
                manager={favoritesManager}
                segmentPlaylistButtonAction={segmentPlaylistButtonAction}
                setFavorite={setFavorite}
                stopNavigationOnClick
                type={FAVORITE_TYPE_WATCHLIST}
              />
            </span>
            <HoverStateToolTip theme={Style} isFavorited={isFavorite} isRightJustified />
          </span>
        </Overlay>
      )}
    </div>
  );
};

export default BrowsePoster;

BrowsePoster.propTypes = {
  account: PropTypes.shape({}),
  breakpoint: PropTypes.string,
  favoritesManager: PropTypes.shape({}),
  isGrid: PropTypes.bool,
  isPersonality: PropTypes.bool,
  item: PropTypes.shape({}),
  itemIndex: PropTypes.number,
  preventLazyLoad: PropTypes.bool,
  segmentPlaylistButtonAction: PropTypes.func,
};
